<template lang="pug">
v-dialog.modal-shipment-item(:value="value", @input="$emit('input', $event)", max-width="850px")
  v-card.pa-5
    v-row
      v-col
        h2.primary--text {{$tc('PackageContent.packageQuantity', 1)}}
      v-spacer
      g-btn(icon, @click="$emit('input', false)")
        v-icon mdi-close
    div.table-container
      table(v-if="hasPackages && hasShipmentItems", id="pckQtyTable")
        thead
          tr
            th
            template(v-for="(pckg, i) in packages")
              template(v-if="isNotDeleted(pckg)")
                th
                  h10 {{ `${$tc('Package._name', 1)} ${findVisibleIndex(visiblePackages, pckg, 'packageNo') + 1} - ${pckg.packaging} ${pckg.caseIdentifier}` }}
            th
              h10  {{ $t('modalPackageQuantity.shippingQty') }}
        tbody
          template(v-for="(shItem, i) in shipmentItems")
            template(v-if="isNotDeleted(shItem)")
              tr
                td
                  h5.primaryHover--text {{ `${$t('modalPackageQuantity.item')} ${findVisibleIndex(visibleShItems, shItem, 'itemNo') + 1}` }}
                template(v-for="(pckg, i) in packages")
                  template(v-if="isNotDeleted(pckg)")
                    td
                      v-text-field(:value="getValue(shItem, pckg, localInstance)", type="number", min="0", @input="setValue($event, shItem, pckg, localInstance)")
                td
                  v-text-field(:value="getShippingQuantity(shItem, localInstance)", disabled)
    v-card-actions
      v-spacer
      g-btn(width="130px", color="primary", @click="submit") {{ $t('Common.submit') }}
      v-spacer

</template>

<style lang="scss" scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
}
#pckQtyTable {
  border-spacing: 15px;
  border-collapse: separate;
  thead {
    th {
      max-width: 120px;
      width: 120px;
      min-width: 120px;
    }
  }
  tbody {
    td {
      ::v-deep .v-input__slot:before {
        border-color: var(--v-primary-base);
      }
      ::v-deep input {
        text-align: center;
        font-weight: 500;
      }
    }
  }
}
</style>

<script>
import EntityMixin from '@/mixins';

export default {
  mixins: [EntityMixin],
  props: ['entity', 'chips', 'invert', 'relation', 'path', 'parent', 'extraData', 'parentInstance', 'selectorOnly', 'showInfo', 'isDraft', 'isActive', 'value', 'pathShipmentItems', 'pathPackages'],
  data: () => ({
    products: [],
    orderLines: [],
    localInstance: [],
  }),
  methods: {
    submit() {
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: [...this.localInstance, ...this.notVisibleContents] });
      this.$emit('input', false);
    },
    isNotDeleted(element) {
      return !(_.get(element, 'entityState') === 2);
    },
    isDeleted(element) {
      return _.get(element, 'entityState') === 2;
    },
    findVisibleIndex(visibleItems, element, path) {
      if (!visibleItems) return null;
      return visibleItems.findIndex(vp => {
        return vp[path] === element[path];
      });
    },
    getShippingQuantity({ itemNo }, arrPackageContent) {
      const filtered = arrPackageContent.filter(content => content.itemNo === itemNo);
      return _.reduce(filtered, (acc, { quantity }) => {
        return acc + Number(quantity);
      }, 0);
    },
    getValue({ itemNo }, { packageNo }, arrPackageContent) {
      const found = this.findPackageContent(itemNo, packageNo, arrPackageContent);
      return found && found.quantity || 0;
    },
    findPackageContent(itemNo, packageNo, arrPackageContent) {
      return arrPackageContent.find(content => ((content.itemNo === itemNo) && (content.packageNo === packageNo)));
      // return arrPackageContent.find(content => ((content.itemNo === itemNo) && (content.packageNo === packageNo))) || { entityState: 4, itemNo, packageNo, quantity: null };
    },
    setValue(value, shItem, pckg, arrPackageContent) {
      let nValue = Number(value);
      let found = this.findPackageContent(shItem.itemNo, pckg.packageNo, arrPackageContent);
      if(shItem.product != null) shItem.product.entityState = 0;
      if(shItem.orderLine != null) shItem.orderLine.entityState = 0;
      if (!found) {
        found = { entityState: 4, itemNo: shItem.itemNo, packageNo: pckg.packageNo, package: pckg, product: shItem.product, orderLine: shItem.orderLine, quantity: nValue };
        arrPackageContent.push(found);
      } else {
        found.quantity = nValue;
        if (found.id) found.entityState = 3;
      }
    },
  },
  computed: {
    shipmentItems() {
      return this.parentInstance[this.pathShipmentItems];
    },
    packages() {
      return this.parentInstance[this.pathPackages];
    },
    hasShipmentItems() {
      return this.shipmentItems && this.shipmentItems.length > 0;
    },
    hasPackages() {
      return this.packages && this.packages.length > 0;
    },
    visiblePackages() {
      return (this.packages || []).filter(this.isNotDeleted);
    },
    visibleShItems() {
      return (this.shipmentItems || []).filter(this.isNotDeleted);
    },
    visibleContents() {
      return (this.instance || []).filter(this.isNotDeleted);
    },
    notVisibleContents() {
      return (this.instance || []).filter(this.isDeleted);
    },
  },
  created() {
    this.localInstance = _.cloneDeep(this.visibleContents);
  },
}
</script>
